import { styled } from '@mui/material/styles';
import { Grid, Paper, Typography, Box } from '@mui/material';

// ===================== PAPER FORM =====================

export const PaperForm = styled(Paper, {
  shouldForwardProp: prop => prop !== 'paperSx',
})(({ theme, paperSx }) => ({
  padding: '40px',
  borderRadius: '8px',
  [theme.breakpoints.down('sm')]: {
    padding: '16px 13px',
    border: 'none',
  },
  // ✅ Permite overrides desde fuera:
  ...paperSx,
}));

// ===================== GRID FORM =====================
export const GridForm = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    marginTop: theme.spacing(2),
  },
}));

// ===================== TITLES =====================
export const SubTitle = styled(Typography)(({ theme }) => ({
  color: 'black',
  fontWeight: 'bold',
  paddingLeft: '15px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '16px',
    paddingLeft: 0,
    paddingBottom: '10px',
  },
}));

export const SubTitlePax = styled(Typography)(({ theme }) => ({
  color: 'black',
  fontWeight: 'bold',
  [theme.breakpoints.down('sm')]: { fontSize: '16px' },
}));

// ===================== SEPARATOR =====================
export const DivSeparatorHorizontal = styled('div')({
  display: 'flex',
  width: '100%',
  textAlign: 'center',
  justifyContent: 'center',
  alignItems: 'center',
  height: 'auto',
  marginTop: '2vw',
  marginBottom: '2vw',
});

export const SeparatorHorizontal = styled(Box)({
  height: '2px',
  width: '100%',
  backgroundColor: '#E5E5E5',
});

// ===================== GRID SUBSIDIARY =====================

export const GridImg = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: { paddingBottom: '10px' },
}));

export const GridButtonSend = styled(Grid)({
  maxHeight: '140px',
  alignSelf: 'end',
});
